import React, { useEffect, useState } from 'react'
import { ConfigProvider, Menu } from 'antd'
import { observer } from 'mobx-react-lite'
import { useStores } from '../../../cls/stores/MobXProvider'
import { routesAccount, flattenRoutesList } from '../../../config/routes'
import { selectedRouteKey, validateRoute } from '../../../config/routes-utils'
import { useLocation } from 'react-router-dom'
import { isMobile } from 'react-device-detect'

const NavBar = observer(({ ...props }) => {
	const stores = useStores()
	const location = useLocation()

	// 1. Items to be displayed in the menu
	const items = []

	// 2. Validate each route and add it to the items array
	routesAccount.forEach((route) => {
		const validItem = validateRoute(route, stores)
		if (validItem) items.push(validItem)
	})

	// 3. Set the selected menu item based on the current route
	const [selectedMenuItem, setSelectedMenuItem] = useState(
		selectedRouteKey(flattenRoutesList, location)
	)

	// 4. Update the selected menu item whenever the route changes
	useEffect(() => {
		setSelectedMenuItem(selectedRouteKey(flattenRoutesList, location))
	}, [location.pathname]) // Use location.pathname to detect route changes

	return (
		<ConfigProvider>
			<Menu
				id="header-menu"
				mode="horizontal"
				selectedKeys={selectedMenuItem}
				onClick={(e) => setSelectedMenuItem(e.keyPath)} // Set selected item and its parent
				items={items}
				style={{
					width: 'fit-content', // Adjust width to fit children
					marginRight: isMobile ? '-17px' : '0px' // Adjust margin for mobile
				}}
				triggerSubMenuAction="click" // Keep submenus active on click
				{...props}
			/>
		</ConfigProvider>
	)
})

export default NavBar
